<template>
      <card>
        <list
          :columns="columns"
          :modalCreate="modalCreate"
          :removeLink="removeLink"
          :cardLink="cardLink"
          :staticFilters="staticFilters"
          :isUpdate="true"
          :isAdd="true"
          :itemLink="itemLink"
          :setLink="setLink"
          :fields="fields"
          :filters="filters"
          :searchDisable="false"
          @change="change"
          @changeFunction="changeFunction"
          v-model="val"
        />
      </card>
</template>
<script>
export default {
  name: "products",
  methods: {
    changeFunction(val) {},
    change(val) {},
  },
  data() {
    return {
             filters: [

      ],
          staticFilters: [
  
        {
          title: "Активность:",
          key: "is_active",
          default: null,
          items: [
            { 
                id:null,
                title:"Показать всех"
            },
            {
              id: "2",
              title: "Активные",
            },
            {
              id: "1",
              title: "Не активные",
            }
          ],
        },
        
        ],
      val: [],
      modalCreate: "dealer",
 fields: [
        {
        col:' col-12 col-md-12',
        key: "phone",
        label: "Номер телефона",
        type: "mask",
        mask: "+998#########",
   
      },
      //   {
      //   col:' col-12 col-md-3',
      //   key: "bonus",
      //   label: "Бонусы",
      //   type: "field",
      //   textType: "number",
      //   readonly:true
      // },

         {
        col:' col-12 col-md-6',
        key: "last_name",
        label: "Фамилия",
        type: "field",
        textType: "text",
      },
      {
        col:' col-12 col-md-6',
        key: "first_name",
        label: "Имя",
        type: "field",
        textType: "text",
      },
   
   

      // {
      //   col:' col-12 col-md-6',
      //   key: "role",
      //   label: "Роль",
      //   type: "select",
      //   modal: "role",
      //   selectKey: "title",
      // },


      //new

      {
        col:' col-12 col-md-6',
        key: "inn",
        label: "ИНН",
        type: "field",
        textType: "text",
      },
      {
        col:' col-12 col-md-6',
        key: "llc_name",
        label: "Название организации",
        type: "field",
        textType: "text",
      },
      {
        col:' col-12 col-md-6',
        key: "trademark",
        label: "Торговая марка",
        type: "field",
        textType: "text",
      },
      {
        col:' col-12 col-md-6',
        key: "accountant_full_name",
        label: "ФИО бухгалтера",
        type: "field",
        textType: "text",
      },
      {
        col:' col-12 col-md-6',
        key: "accountant_phone",
        label: "Телефон бухгалтерии",
        type: "field",
        textType: "text",
      },
      {
        col:' col-12 col-md-6',
        key: "organizationa_address",
        label: "Юр. адрес орг",
        type: "field",
        textType: "text",
      },

      {
        col:' col-12 col-md-6',
        key: "checking_account",
        label: "Расчетный счет",
        type: "field",
        textType: "text",
      },
      {
        col:' col-12 col-md-6',
        key: "mfo",
        label: "МФО банка",
        type: "field",
        textType: "text",
      },
      {
        col:' col-12 col-md-6',
        key: "oked",
        label: "ОКЭД",
        type: "field",
        textType: "text",
      },


    ],
      /** APIs */
      removeLink: "",
      cardLink: "item_dealer",
      itemLink: "my-dealers",
      setLink: "my-dealers",
      columns: [
        {
          key: "id",
          title: "ID",
          checkbox: false,
          control: false,
          align: "left",
          timer: false,
          detail: false,
          sortBy:'id'
        },
        {
          key: "llc_name",
          title: "Название оргранизации",
          checkbox: false,
          control: false,
          align: "left",
          timer: false,
          detail: false,
        },
        {
          key: "first_name",
          title: "Имя",
          checkbox: false,
          control: false,
          align: "left",
          timer: false,
          detail: false,
        },
        {
          key: "last_name",
          title: "Фамилия",
          checkbox: false,
          control: false,
          align: "left",
          timer: false,
          detail: false,
        },
        {
          key: "phone",
          title: "Номер телефона",
          checkbox: false,
          control: false,
          align: "left",
          timer: false,
          detail: false,
        },
   
    
        {
          key: "is_active",
          title: "Активность",
          checkbox: false,
          control: false,
          align: "left",
          timer: false,
          detail: false,
        },
        {
          detail: true,
          // remove: true,
        },
      ],
    };
  },
};
</script>
<style>
</style>
